import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { APP_COPY } from '../../constants/copy';
import Hero from '../../components/Hero/hero';
import Cta from '../../components/Cta/cta';
import './home.scss';

const Home = () => {
  const navigate = useNavigate();

  const scrollToContact = () => {
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToRetreats = () => {
    navigate('/retreats');
  };

  return (
    <section id="home" className="home">
      {/* Hero Section */}
      <Hero
        title={APP_COPY.home.hero.title}
        subtitle={APP_COPY.home.hero.subtitle}
        cta={APP_COPY.home.hero.cta}
        secondaryCta="Book a Retreat"
        onCtaClick={goToRetreats}
        onSecondaryCtaClick={scrollToContact}
      />

      {/* Welcome Section */}
      <section className="home__welcome py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="home__welcome-content">
                <h2 className="home__section-title">{APP_COPY.home.mainDescription.title}</h2>
                <p className="home__welcome-text">{APP_COPY.home.mainDescription.content}</p>
                <div className="home__welcome-features">
                  <div className="home__feature-item">
                    <i className="fas fa-pray"></i>
                    <span>Prayerful Atmosphere</span>
                  </div>
                  <div className="home__feature-item">
                    <i className="fas fa-users"></i>
                    <span>Community Focus</span>
                  </div>
                  <div className="home__feature-item">
                    <i className="fas fa-heart"></i>
                    <span>Spiritual Growth</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="home__welcome-card">
                <div className="home__atmosphere">
                  <h4 className="home__card-title">
                    <i className="fas fa-star me-2"></i>
                    Our Atmosphere
                  </h4>
                  <p className="home__card-text">{APP_COPY.home.mainDescription.atmosphere}</p>
                  <div className="home__contact-info">
                    <h5 className="home__contact-title">Contact Information</h5>
                    <div className="home__contact-item">
                      <i className="fas fa-envelope"></i>
                      <a href="mailto:info@stdominicsbluff.org.za">info@stdominicsbluff.org.za</a>
                    </div>
                    <div className="home__contact-item">
                      <i className="fas fa-phone"></i>
                      <span>031 467 3721</span>
                    </div>
                    <div className="home__contact-item">
                      <i className="fas fa-mobile-alt"></i>
                      <span>079 538 0846</span>
                    </div>
                    <div className="home__contact-item">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>10 Baudry Rd, Ocean View, Bluff, 4052</span>
                    </div>
                    <div className="home__contact-item">
                      <i className="fas fa-clock"></i>
                      <span>Mon-Fri 8am-4pm, Sat 8am-12pm</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Facilities Section */}
      <section className="home__facilities py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="home__section-title">{APP_COPY.home.facilities.title}</h2>
            </div>
          </div>
          
          <div className="row g-4 mt-4">
            {APP_COPY.home.facilities.items.map((facility, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="home__facilities-card">
                  <div className="home__card-icon">
                    <i className="fas fa-building"></i>
                  </div>
                  <h4 className="home__card-title">{facility.title}</h4>
                  <p className="home__card-text">{facility.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="home__features py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="home__section-title">{APP_COPY.home.features.title}</h2>
            </div>
          </div>
          
          <div className="row g-4 mt-4">
            {APP_COPY.home.features.items.map((feature, index) => {
              const featureLinks = [
                '/retreats#short-retreats',
                '/retreats#directed-retreats',
                '/retreats#online-spiritual'
              ];
              const to = featureLinks[index] || '/retreats';
              return (
                <div key={index} className="col-lg-4 col-md-6">
                  <Link to={to} className="home__features-card d-block text-decoration-none">
                    <div className="home__card-icon">
                      <i className="fas fa-star"></i>
                    </div>
                    <h4 className="home__card-title">{feature.title}</h4>
                    <p className="home__card-text">{feature.description}</p>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      {/* Call to Action Section */}
        <Cta 
          title="Ready to Experience St. Dominic's<br />House of Prayer?"
          subtitle="Book your retreat today and discover the perfect place for spiritual reflection and community connection."
          primaryButton={{ 
            text: 'Long retreat brochure',
            onClick: () => window.open('/long-retreat.pdf', '_blank')
          }}
          secondaryButton={{ 
            text: 'Short retreat brochure',
            onClick: () => window.open('/short-retreat.pdf', '_blank')
          }}
        />
    </section>
  );
};

export default Home; 